"use client";

import React, { createContext, useContext, useState } from "react";

const FooterContext = createContext({
  actions: {},
  setActions: () => {},
});

export function FooterProvider({ children }) {
  const [actions, setActions] = useState({});
  return (
    <FooterContext.Provider value={{ actions, setActions }}>
      {children}
    </FooterContext.Provider>
  );
}

export function useFooter() {
  return useContext(FooterContext);
}
